import Brlang from './entries/pt-BR';

const AppLocale = {
  br: Brlang
};

export default AppLocale;
